import { common } from './common';
import { userpath } from './userpath';

export const en = {
  common,
  userpath,
};
